import styled from 'styled-components';

export const Section = styled.section`
  padding: 100px 0;
  background-color: #0a192f;
  color: #ccd6f6;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 2.5em;
  margin-bottom: 20px;
`;

export const Text = styled.p`
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.5;
`;

